import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './DeletePosting.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePostingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeletePostingMutation = (
  { __typename?: 'Mutation' }
  & { postingsDeletePosting?: Types.Maybe<(
    { __typename?: 'PostingsPostingDeleteResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'PostingsError' }
      & Pick<Types.PostingsError, 'message' | 'details'>
    )> }
  )> }
);


export type DeletePostingMutationFn = Apollo.MutationFunction<DeletePostingMutation, DeletePostingMutationVariables>;

/**
 * __useDeletePostingMutation__
 *
 * To run a mutation, you first call `useDeletePostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostingMutation, { data, loading, error }] = useDeletePostingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePostingMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostingMutation, DeletePostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostingMutation, DeletePostingMutationVariables>(Operations.DeletePosting, options);
      }
export type DeletePostingMutationHookResult = ReturnType<typeof useDeletePostingMutation>;
export type DeletePostingMutationResult = Apollo.MutationResult<DeletePostingMutation>;
export type DeletePostingMutationOptions = Apollo.BaseMutationOptions<DeletePostingMutation, DeletePostingMutationVariables>;